import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class TaxLiabilityDashboardService {

  constructor(private http: HttpClient) { }

  getTaxLiability(
    tax_year: string,
    combination_key: string,
    group_id: number,
    baseUrl: string,
    globalService: any,
    filterParams: any = {},
    rowData: any = {}
  ): Observable<any> {
    // 🚀 CRITICAL: Build params with all required fields for action code 'nullj8'
    const params: any = {
      "action_code": "nullj8",
      "activity_key": filterParams?.activity_key || globalService?.activity_key || '6507',
      "combination_key": combination_key || rowData?.COMBINATION_KEY || '',
      "filing_key": filterParams?.filing_key || globalService?.filing_key || rowData?.FILING_KEY || rowData?.CONSOL_GROUP_KEY || '1',
      "group_id": group_id || rowData?.GROUP_ID || 0,
      "is_issue_key_enabled": filterParams?.is_issue_key_enabled || globalService?.is_issue_key_enabled || 'N',
      "is_locked": filterParams?.is_locked || globalService?.is_locked || 'N',
      "issue_id": filterParams?.issue_id || globalService?.issue_id || '',
      "issue_id_for_tx_save": filterParams?.issue_id_for_tx_save || globalService?.issue_id_for_tx_save || '',
      "issue_short_desc": filterParams?.issue_short_desc || globalService?.issue_short_desc || '',
      "jcd_key": filterParams?.jcd_key || globalService?.jcd_key || rowData?.JCD_KEY || '250',
      "jcd_ta_key": filterParams?.jcd_ta_key || globalService?.jcd_ta_key || '5347',
      "parent_me_string": filterParams?.parent_me_string || globalService?.parent_me_string || '',
      "scenario": filterParams?.scenario || globalService?.scenario || '74',
      "scenarioCode": filterParams?.scenarioCode || filterParams?.scenario_code || globalService?.scenarioCode || 'RAF',
      "screen_key": filterParams?.screen_key || globalService?.screen_key || '10740',
      "screen_type": filterParams?.screen_type || globalService?.screen_type || 'grid',
      "tax_year": tax_year || filterParams?.tax_year || globalService?.tax_year || rowData?.TAX_YEAR || ''
    };

    // 🚀 CRITICAL: Build query string from params
    const urlParams = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlParams.set(key, params[key].toString());
      }
    });

    // 🚀 CRITICAL: URL construction with query string parameters
    const url = `${baseUrl}/loadJsonObject?${urlParams.toString()}`;

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      }),
      withCredentials: true
    };

    // Send empty body since all params are in query string
    return this.http.post<any>(url, '', httpOptions);
  }

  getTotalTaxLiability(
    tax_year: string,
    combination_key: string,
    group_id: number,
    baseUrl: string,
    globalService: any,
    filterParams: any = {},
    rowData: any = {}
  ): Observable<any> {
    // 🚀 CRITICAL: Build params with all required fields for action code 'zo47bc'
    // Match the exact payload structure provided
    const params: any = {
      "action_code": "zo47bc",
      "activity_key": filterParams?.activity_key || globalService?.activity_key || '6507',
      "combination_key": combination_key || rowData?.COMBINATION_KEY || '',
      "filing_key": filterParams?.filing_key || globalService?.filing_key || rowData?.FILING_KEY || rowData?.CONSOL_GROUP_KEY || '1',
      "group_id": group_id || rowData?.GROUP_ID || 0,
      "is_issue_key_enabled": filterParams?.is_issue_key_enabled || globalService?.is_issue_key_enabled || 'N',
      "is_locked": filterParams?.is_locked || globalService?.is_locked || 'N',
      "issue_id": filterParams?.issue_id || globalService?.issue_id || '',
      "issue_id_for_tx_save": filterParams?.issue_id_for_tx_save || globalService?.issue_id_for_tx_save || '',
      "issue_short_desc": filterParams?.issue_short_desc || globalService?.issue_short_desc || '',
      "jcd_key": filterParams?.jcd_key || globalService?.jcd_key || rowData?.JCD_KEY || '250',
      "jcd_ta_key": filterParams?.jcd_ta_key || globalService?.jcd_ta_key || '5347',
      "parent_me_string": filterParams?.parent_me_string || globalService?.parent_me_string || '',
      "scenario": filterParams?.scenario || globalService?.scenario || '74',
      "scenarioCode": filterParams?.scenarioCode || filterParams?.scenario_code || globalService?.scenarioCode || 'RAF',
      "screen_key": filterParams?.screen_key || globalService?.screen_key || '10740',
      "screen_type": filterParams?.screen_type || globalService?.screen_type || 'grid',
      "tax_year": tax_year || filterParams?.tax_year || globalService?.tax_year || rowData?.TAX_YEAR || ''
    };

    // 🚀 CRITICAL: Build query string from params
    const urlParams = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlParams.set(key, params[key].toString());
      }
    });

    // 🚀 CRITICAL: URL construction with query string parameters
    const url = `${baseUrl}/loadJsonObject?${urlParams.toString()}`;

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      }),
      withCredentials: true
    };

    // Send empty body since all params are in query string
    return this.http.post<any>(url, '', httpOptions);
  }

  getStatus(
    tax_year: string,
    combination_key: string,
    baseUrl: string,
    globalService: any,
    filterParams: any = {},
    rowData: any = {}
  ): Observable<any> {
    const url = `${baseUrl}/loadJsonObject?action_code=p7vu4i`;
    
    // 🚀 CRITICAL: Build params with all required fields for action code 'p7vu4i'
    const params: any = {
      "action_code": "p7vu4i",
      "activity_key": filterParams?.activity_key || globalService?.activity_key || '6507',
      "combination_key": combination_key,
      "filing_key": filterParams?.filing_key || globalService?.filing_key || rowData?.FILING_KEY || rowData?.CONSOL_GROUP_KEY || '1',
      "is_issue_key_enabled": filterParams?.is_issue_key_enabled || globalService?.is_issue_key_enabled || 'N',
      "is_locked": filterParams?.is_locked || globalService?.is_locked || 'N',
      "issue_id": filterParams?.issue_id || globalService?.issue_id || '',
      "issue_id_for_tx_save": filterParams?.issue_id_for_tx_save || globalService?.issue_id_for_tx_save || '',
      "issue_short_desc": filterParams?.issue_short_desc || globalService?.issue_short_desc || '',
      "jcd_key": filterParams?.jcd_key || globalService?.jcd_key || rowData?.JCD_KEY || '250',
      "jcd_ta_key": filterParams?.jcd_ta_key || globalService?.jcd_ta_key || '5347',
      "parent_me_string": filterParams?.parent_me_string || globalService?.parent_me_string || '',
      "scenario": filterParams?.scenario || globalService?.scenario || '74',
      "scenarioCode": filterParams?.scenarioCode || filterParams?.scenario_code || globalService?.scenarioCode || globalService?.scenario_code || 'RAF',
      "screen_key": filterParams?.screen_key || globalService?.screen_key || '10740',
      "screen_type": filterParams?.screen_type || globalService?.screen_type || 'grid',
      "tax_year": tax_year
    };

    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      }),
      withCredentials: true
    };

    return this.http.post<any>(url, urlEncoded.toString(), httpOptions);
  }

  save(
    _data: any[],
    settings: any[],
    baseUrl: string,
    globalService: any,
    filterParams: any = {},
    rowData: any = {}
  ): Observable<any> {
    const url = `${baseUrl}/saveJsonObject?action_code=sukz5u`;
    
    let params: any = _.merge({}, globalService || {}, filterParams);
    const jsonSetting = JSON.stringify(settings);
    const jsonObj = JSON.stringify(_data);
    
    params = _.extend({ jsonObj: jsonObj }, params);
    params = _.extend({ jsonSetting: jsonSetting }, params);

    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      }),
      withCredentials: true
    };

    return this.http.post<any>(url, urlEncoded.toString(), httpOptions);
  }

  delete(
    _data: any,
    isDelete: boolean,
    baseUrl: string,
    globalService: any,
    filterParams: any = {},
    rowData: any = {}
  ): Observable<any> {
    const url = `${baseUrl}/saveJsonObject?action_code=zndef9`;
    
    let params: any = _.merge({}, globalService || {}, filterParams);
    
    const jsonSettings = [{
      tax_year: _data.TAX_YEAR || rowData.TAX_YEAR || filterParams?.tax_year,
      combination_keys: _data.combination_key
    }];
    
    const jsonObj = JSON.stringify(_data);
    
    params = _.extend({ jsonSetting: JSON.stringify(jsonSettings) }, params);
    params = _.extend({ jsonObj: jsonObj }, params);

    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      }),
      withCredentials: true
    };

    return this.http.post<any>(url, urlEncoded.toString(), httpOptions);
  }

  saveStatus(
    _data: any[],
    baseUrl: string,
    globalService: any,
    filterParams: any = {},
    rowData: any = {}
  ): Observable<any> {
    const url = `${baseUrl}/saveJsonObject?action_code=514k49`;
    
    // 🚀 CRITICAL: Build params with all required fields for action code '514k49'
    let params: any = _.merge({}, globalService || {}, filterParams);
    
    // Build jsonSetting as [{}] (empty object array) as per requirement
    const jsonSettings = [{}];
    
    // Build jsonObj from _data
    const jsonObj = JSON.stringify(_data);
    
    // Add jsonObj and jsonSetting
    params = _.extend({ jsonObj: jsonObj }, params);
    params = _.extend({ jsonSetting: JSON.stringify(jsonSettings) }, params);
    
    // Add all required parameters with proper fallback chains
    params.tax_year = filterParams?.tax_year || globalService?.tax_year || '';
    params.screen_key = filterParams?.screen_key || globalService?.screen_key || '';
    params.scenario = filterParams?.scenario || globalService?.scenario || '';
    params.jcd_key = filterParams?.jcd_key || globalService?.jcd_key || '';
    params.jcd_ta_key = filterParams?.jcd_ta_key || globalService?.jcd_ta_key || '';
    params.activity_key = filterParams?.activity_key || globalService?.activity_key || '';
    params.screen_type = filterParams?.screen_type || globalService?.screen_type || 'grid';
    params.is_locked = filterParams?.is_locked || globalService?.is_locked || 'N';
    params.issue_id = filterParams?.issue_id || globalService?.issue_id || '';
    params.issue_short_desc = filterParams?.issue_short_desc || globalService?.issue_short_desc || '';
    params.issue_id_for_tx_save = filterParams?.issue_id_for_tx_save || globalService?.issue_id_for_tx_save || '';
    params.scenarioCode = filterParams?.scenarioCode || filterParams?.scenario_code || globalService?.scenarioCode || globalService?.scenario_code || 'RAF';
    params.is_issue_key_enabled = filterParams?.is_issue_key_enabled || globalService?.is_issue_key_enabled || 'N';
    params.filing_key = filterParams?.filing_key || globalService?.filing_key || rowData?.FILING_KEY || rowData?.CONSOL_GROUP_KEY || '';
    params.parent_me_string = filterParams?.parent_me_string || globalService?.parent_me_string || '';

    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      }),
      withCredentials: true
    };

    return this.http.post<any>(url, urlEncoded.toString(), httpOptions);
  }
}







